<template>
  <section class="bg-gray-3 rounded-[16px] pl-6 pt-4 card-functionality mx-auto">
    <div class="pb-4 pt-2"><slot name="icon">[icon]</slot></div>
		<div class="pb-2 font-bold text-lg"><slot name="title">Title</slot></div>
		<div class="pb-4 text-[15px]"><slot name="content"> content by default </slot></div>
  </section>
</template>
